import {
  ParagraphAccordeon,
  ParagraphBlockReference,
  ParagraphContactPerson,
  ParagraphCta,
  ParagraphCtaDouble,
  ParagraphCtaBlockReference,
  ParagraphCtaLandingpage,
  ParagraphCustomHtml,
  ParagraphDonation,
  ParagraphDownloads,
  ParagraphHighlightedArticleOrStory,
  ParagraphHighlightedThemes,
  ParagraphIconWrapper,
  ParagraphImage,
  ParagraphImageGrid,
  ParagraphFrame,
  ParagraphLandingSelectedArticles,
  ParagraphLandingSelectedProjects,
  ParagraphLandingSelectedStories,
  ParagraphLandingSelectedVacancies,
  ParagraphLandingTextImage,
  ParagraphLatestArticles,
  ParagraphLatestMunicipalityArticles,
  ParagraphLatestPointsOfView,
  ParagraphLatestProjects,
  ParagraphLatestStories,
  ParagraphLatestVacancies,
  ParagraphLatestThemes,
  ParagraphLinkList,
  ParagraphMoreInfo,
  ParagraphMultiTextImage,
  ParagraphNewsletter,
  ParagraphNumbers,
  ParagraphPopupSuspense,
  ParagraphQuote,
  ParagraphRecentContent,
  ParagraphSearch,
  ParagraphSection,
  ParagraphSelectedArticles,
  ParagraphSelectedProjects,
  ParagraphSelectedStories,
  ParagraphSelectedVacancies,
  ParagraphStandpoint,
  ParagraphText,
  ParagraphTextImage,
  ParagraphVacancyLocations,
  ParagraphVideo,
  ParagraphWebform,
  ParagraphCtaCampaign,
  ParagraphSocialMediaEmbed,
} from '../implementations';

const mappers = {
  accordeon: ParagraphAccordeon,
  action_icon_wrapper: ParagraphIconWrapper,
  block_reference: ParagraphBlockReference,
  contact_person: ParagraphContactPerson,
  cta_landingpage: ParagraphCtaLandingpage,
  call_to_action_campagne: ParagraphCtaCampaign,
  cta: ParagraphCta,
  call_to_action_block_reference: ParagraphCtaBlockReference,
  cta_double: ParagraphCtaDouble,
  custom_html: ParagraphCustomHtml,
  donation: ParagraphDonation,
  downloads: ParagraphDownloads,
  highlighted_article_story: ParagraphHighlightedArticleOrStory,
  highlighted_themes: ParagraphHighlightedThemes,
  image_grid: ParagraphImageGrid,
  image: ParagraphImage,
  frame: ParagraphFrame,
  landing_selected_articles: ParagraphLandingSelectedArticles,
  landing_selected_projects: ParagraphLandingSelectedProjects,
  landing_selected_stories: ParagraphLandingSelectedStories,
  landing_selected_vacancies: ParagraphLandingSelectedVacancies,
  landing_text_image: ParagraphLandingTextImage,
  latest_articles: ParagraphLatestArticles,
  latest_municipality_articles: ParagraphLatestMunicipalityArticles,
  latest_points_of_view: ParagraphLatestPointsOfView,
  latest_projects: ParagraphLatestProjects,
  latest_stories: ParagraphLatestStories,
  latest_vacancies: ParagraphLatestVacancies,
  latest_themes: ParagraphLatestThemes,
  link_list: ParagraphLinkList,
  more_info: ParagraphMoreInfo,
  multiple_text_image: ParagraphMultiTextImage,
  newsletter_signup: ParagraphNewsletter,
  numbers: ParagraphNumbers,
  popup: ParagraphPopupSuspense,
  quote: ParagraphQuote,
  recent_content: ParagraphRecentContent,
  search: ParagraphSearch,
  section: ParagraphSection,
  selected_articles: ParagraphSelectedArticles,
  selected_projects: ParagraphSelectedProjects,
  selected_stories: ParagraphSelectedStories,
  selected_vacancies: ParagraphSelectedVacancies,
  standpoint: ParagraphStandpoint,
  social_media_embed: ParagraphSocialMediaEmbed,
  text_image: ParagraphTextImage,
  text: ParagraphText,
  vacancy_locations: ParagraphVacancyLocations,
  video: ParagraphVideo,
  webform: ParagraphWebform,
};

export default mappers;
